interface Action {
    payload: any,
    type: string,
    field: string,
    apiError?: string | boolean,
    value?: any,
    validate: boolean
}

const errors: {
    [key: string]: string
} = {
    newPassword: "Please add a password.",
    confirmPassword: "Please confirm the password.",
    password: "Please add a password.",
    doesNotMatch: "Password does not match.",
    validEmail: "Please add a valid email address.",
    userExist: 'We cannot find an account with that email address.'
};

const passwordPattern: {
    [key: string]: any
} = {
    n: /[0-9]/,
    u: /[A-Z]/,
    l: /[a-z]/
};
const passwordLength = 8;
const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,50}$/;


export default (data: any, action: Action) => {
    const newForm = data;
    const prop = newForm[action.field];

    if (prop) {

        if (!prop.dirty && action.validate) {
            prop.dirty = true;
        }

        if (action.field === 'email') {
            prop.error = !emailPattern.test(action.value) ? errors['validEmail'] : null;
            prop.error =  action.apiError ? (typeof action.apiError === 'string' ? action.apiError : errors['userExist']) : prop.error;;

            prop.value = action.value;
            return {
                changed: true,
                valid: !!prop.error,
                data: newForm,
            };
        } else {
            delete newForm.email;

            if (!prop.added && (action.value || (!action.value && action.validate))) {
                prop.added = true
            }
            if ((action.field === 'newPassword' || action.field === 'confirmPassword') && action.value) {
                for (const p in passwordPattern) {
                    prop.errTypes[p] = !passwordPattern[p].test(action.value);
                }
                prop.errTypes.min = (action.value || '').length < passwordLength;
                prop.error = Object.values(prop.errTypes).includes(true) ? errors['password'] : null;
            } else {
                prop.error = (prop.added && !action.value && prop.required) ? errors[action.field] : null;
            }
            prop.value = action.value;
            if (newForm.newPassword.value && newForm.confirmPassword.value) {
                newForm.confirmPassword.error =
                    (newForm.newPassword.value !== newForm.confirmPassword.value) ? errors.doesNotMatch : null;
            }

            const vals = Object.values(newForm).filter((f: any) => f.required);
            const valid = vals.filter((f: any) => f.added && f.value && !f.error);
            return {
                changed: true,
                valid: valid.length === vals.length,
                data: newForm,
            };
        }
    }
};
